import { motion } from "framer-motion";
import ReviewsGrid from "./ReviewsGrid";
import googleIcon from "../../assets/Icons/google-icon.png";
import { EXTERNAL_LINKS } from "../../constants/externalLinks";

export default function Reviews() {
  return (
    <section
      style={{
        background: "linear-gradient(160deg, #060d18 0%, #0d1b2e 50%, #081422 100%)",
        padding: "clamp(56px, 9vw, 100px) 0",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background dot grid */}
      <div className="rv-grid" />

      {/* Glow blobs */}
      <div className="rv-blob rv-blob-1" />
      <div className="rv-blob rv-blob-2" />

      <div
        style={{
          maxWidth: "1160px",
          margin: "0 auto",
          padding: "0 clamp(16px, 4vw, 32px)",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          style={{ textAlign: "center", marginBottom: "clamp(36px, 6vw, 60px)" }}
        >
          {/* Google rating badge */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "rgba(255,255,255,0.06)",
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "999px",
              padding: "10px 24px",
              marginBottom: "20px",
            }}
          >
            <img src={googleIcon} alt="Google" width={18} height={18} />
            <span
              style={{
                color: "#fff",
                fontWeight: 700,
                fontSize: "0.85rem",
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              5.0
            </span>
            <span style={{ color: "#FFD700", fontSize: "1rem", letterSpacing: "2px" }}>
              ★★★★★
            </span>
            <span
              style={{
                color: "rgba(255,255,255,0.5)",
                fontSize: "0.8rem",
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              on Google Reviews
            </span>
          </div>

          <h2
            style={{
              fontSize: "clamp(2rem, 6vw, 3.8rem)",
              fontWeight: 900,
              color: "#fff",
              fontFamily: "'Montserrat', 'Segoe UI', sans-serif",
              letterSpacing: "-1.5px",
              margin: "0 0 14px",
              textShadow: "0 4px 30px rgba(0,0,0,0.4)",
            }}
          >
            What{" "}
            <span
              style={{
                background: "linear-gradient(90deg, #6dc744, #4a8c25)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              People
            </span>{" "}
            Say
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,0.5)",
              fontSize: "clamp(0.92rem, 2vw, 1.1rem)",
              maxWidth: "440px",
              margin: "0 auto",
              lineHeight: 1.65,
            }}
          >
            Hear from the community that makes our market special every week.
          </p>
        </motion.div>

        {/* Reviews grid */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.65 }}
        >
          <ReviewsGrid />
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          style={{ textAlign: "center", marginTop: "clamp(28px, 4vw, 44px)" }}
        >
          <a
            href={EXTERNAL_LINKS.googleReviews}
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "rgba(255,255,255,0.08)",
              backdropFilter: "blur(12px)",
              border: "1.5px solid rgba(255,255,255,0.18)",
              color: "#fff",
              padding: "0.9em 2.4em",
              borderRadius: "999px",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "1rem",
              fontFamily: "'Montserrat', sans-serif",
              letterSpacing: "0.3px",
              transition: "background 0.2s, border-color 0.2s",
            }}
            className="rv-cta-btn"
          >
            <img src={googleIcon} alt="Google" width={18} height={18} />
            See All Reviews on Google
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M2.5 7.5h10M7.5 2.5l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </motion.div>
      </div>

      <style>{`
        .rv-grid {
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
          background-size: 44px 44px;
          pointer-events: none;
        }
        .rv-blob {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
          filter: blur(90px);
        }
        .rv-blob-1 {
          width: 500px; height: 500px;
          background: rgba(109,199,68,0.07);
          top: -150px; right: -120px;
        }
        .rv-blob-2 {
          width: 380px; height: 380px;
          background: rgba(45,106,20,0.12);
          bottom: -100px; left: -100px;
        }
        .rv-cta-btn:hover {
          background: rgba(255,255,255,0.14) !important;
          border-color: rgba(255,255,255,0.35) !important;
        }
      `}</style>
    </section>
  );
}
